class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.init();
        this.addEventListener('change', this.onVariantChange);
    }

    init() {
        window.hasVariants = true;
        this.updateOptions();
        this.updateMasterId();
        this.setCurrentMedia();
        
        // Show badge on initial load
        const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
        if (mediaGallery) {
            setTimeout(() => {
                this.moveBadgeToFirstSlide(mediaGallery);
            }, 100);
        }
        
        window.addEventListener("load", () => {
            this.thumbnailEventListeners(true);
            // Ensure badge is shown on initial load after everything is ready
            if (mediaGallery) {
                setTimeout(() => {
                    this.moveBadgeToFirstSlide(mediaGallery);
                }, 200);
            }
        })
    }
  
    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
  
        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateMedia();
            this.thumbnailEventListeners();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
        }
    }
  
    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }
  
    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    setCurrentMedia() {
        const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
        const mediaGalleryThumbnails = document.getElementById(`MediaGalleryThumbnails-${this.dataset.section}`);
        if (!mediaGallery) return;
        
        // If no variant or no featured media, just ensure badge is on first slide and return
        if (!this.currentVariant || !this.currentVariant.featured_media) {
            // Wait for DOM to be ready
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    this.moveBadgeToFirstSlide(mediaGallery);
                });
            });
            return;
        }
        
        const mediaVariantId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
        const mediaVariant = mediaGallery.querySelector(`[data-media-id="${mediaVariantId}"]`);
        const mediaVariantThumbnail = mediaGalleryThumbnails?.querySelector(`[data-media-id="${mediaVariantId}"]`);
        
        if (!mediaVariant) {
            console.warn(`Variant featured media not found in gallery: ${mediaVariantId}`);
            return;
        }
        
        const variantImages = Array.from(mediaGallery.querySelectorAll('.js-pdp-media-gallery-variant'));
        const variantThumbnails = mediaGalleryThumbnails ? Array.from(mediaGalleryThumbnails.querySelectorAll('.js-pdp-media-gallery-thumbnail-variant')) : [];
        
        // Move variant images which aren't the current variant to end of slider
        variantImages.forEach(image => {
            if (image !== mediaVariant && image.parentNode === mediaGallery) {
                mediaGallery.removeChild(image);
                mediaGallery.appendChild(image);
            }
        })

        // Move variant thumbnails which aren't the current variant to end of slider
        variantThumbnails.forEach(thumb => {
            if (thumb !== mediaVariantThumbnail && thumb.parentNode === mediaGalleryThumbnails) {
                mediaGalleryThumbnails.removeChild(thumb);
                mediaGalleryThumbnails.appendChild(thumb);
            }
        })
        
        // Remove the current variant <li> element from its current position
        if (mediaVariant.parentNode === mediaGallery) {
            mediaGallery.removeChild(mediaVariant);
            // Insert the current variant <li> element at the 1st position (index 0)
            mediaGallery.insertBefore(mediaVariant, mediaGallery.firstChild);
        }
        
        if(mediaVariantThumbnail && mediaGalleryThumbnails && mediaVariantThumbnail.parentNode === mediaGalleryThumbnails) {
            mediaGalleryThumbnails.removeChild(mediaVariantThumbnail);
            mediaGalleryThumbnails.insertBefore(mediaVariantThumbnail, mediaGalleryThumbnails.firstChild);
        }
        
        // Update swiper after DOM changes
        if (window.pdpCarousel) {
            window.pdpCarousel.update();
            window.pdpCarousel.slideTo(0, 0);
        }
        
        if (window.pdpCarouselThumbnails) {
            window.pdpCarouselThumbnails.update();
            window.pdpCarouselThumbnails.slideTo(0, 0);
        }
        
        // Move badge to first slide - use multiple delays to ensure DOM/Swiper is ready
        // Try immediately first (in case slideTo(0,0) is instant)
        this.moveBadgeToFirstSlide(mediaGallery);
        
        // Then try again after a short delay for Swiper to update
        setTimeout(() => {
            this.moveBadgeToFirstSlide(mediaGallery);
        }, 100);
        
        // Final fallback after longer delay
        setTimeout(() => {
            this.moveBadgeToFirstSlide(mediaGallery);
        }, 300);
        
        if (window.pdpCarouselThumbnails) {
            window.pdpCarouselThumbnails.update();
            window.pdpCarouselThumbnails.slideTo(0, 0);
        }
        
        // Make sure correct thumbnail button is active
        if (mediaGalleryThumbnails) {
            mediaGalleryThumbnails.querySelectorAll('.js-pdp-media-gallery-thumbnail').forEach((btn, index) => {
                if (index == 0) {
                    if (!btn.classList.contains('is-active')) {
                        btn.classList.add('is-active')
                    }
                } else {
                    btn.classList.remove('is-active')
                }
            });
        }

        if (mediaGallery) {
            mediaGallery.scrollIntoView({ behavior: 'smooth' });
        }
    }

    moveBadgeToFirstSlide(mediaGallery) {
        if (!mediaGallery) return;
        
        // Get the single absolutely positioned badge - try multiple ways to find it
        const sectionId = this.dataset.section;
        let badge = document.getElementById(`BadgePdpHero-${sectionId}`);
        
        if (!badge) {
            // Fallback: find by class from the swiper container
            const swiperContainer = mediaGallery.closest('.swiper');
            if (swiperContainer) {
                badge = swiperContainer.querySelector('.js-badge-pdp-hero-absolute');
            }
        }
        
        if (!badge) {
            console.warn('Badge not found for section:', sectionId);
            return;
        }
        
        // Check if we're on desktop (has desktop class or no swiper)
        const swiperContainer = mediaGallery.closest('.swiper');
        const isDesktop = swiperContainer && swiperContainer.classList.contains('js-pdp-media-gallery-desktop');
        
        // Get all slides excluding Swiper duplicates
        const allSlides = Array.from(mediaGallery.querySelectorAll('.swiper-slide')).filter(
            slide => !slide.classList.contains('swiper-slide-duplicate')
        );
        
        // Always show badge on desktop, show on first slide only on mobile
        if (allSlides.length === 0) {
            badge.classList.add('hidden');
            return;
        }

        if (isDesktop) {
            // Desktop: always show badge
            badge.classList.remove('hidden');
            return;
        }

        // Mobile: badge visibility handled by Swiper's slide change, but ensure it's set correctly now
        if (window.pdpCarousel) {
            const realIndex = window.pdpCarousel.realIndex !== undefined ? window.pdpCarousel.realIndex : window.pdpCarousel.activeIndex;
            if (realIndex === 0) {
                badge.classList.remove('hidden');
            } else {
                badge.classList.add('hidden');
            }
        } else {
            // No Swiper yet, default to showing on first slide
            badge.classList.remove('hidden');
        }
    }

    thumbnailEventListeners() {
        const mediaGalleryThumbnails = document.getElementById(`MediaGalleryThumbnails-${this.dataset.section}`);

        // Re add event listners after DOM change
        if (mediaGalleryThumbnails) {
            mediaGalleryThumbnails.querySelectorAll('.js-pdp-media-gallery-thumbnail').forEach((button, index) => {
                button.addEventListener('click', () => {
                    window.pdpCarousel?.slideTo(index)
                });
            });
        }

        // Slide both carousels to start
        window.pdpCarousel?.slideTo(0);
        window.pdpCarouselThumbnails?.slideTo(0);
    }
  
    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;

        this.setCurrentMedia();
  
        const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        if (!modalContent) return;
        const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
        modalContent.prepend(newMediaModal);
    }
  
    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }
  
    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;
  
        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }
  
    removeErrorMessage() {
        const section = this.closest('.section');
        if (!section) return;
  
        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
    }
  
    renderProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destination = document.getElementById(`price-${this.dataset.section}`);
                const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                if (source && destination) destination.innerHTML = source.innerHTML;
  
                const price = document.getElementById(`price-${this.dataset.section}`);
  
                if (price) price.classList.remove('visibility-hidden');
                this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
            });
    }
  
    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;
  
        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            addButtonText.textContent = window.variantStrings.addToCart;
        }
  
        if (!modifyClass) return;
    }
  
    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('visibility-hidden');
    }
  
    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

if(!customElements.get('variant-selects')) {
    customElements.define('variant-selects', VariantSelects);
}

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }
  
    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }
}

if(!customElements.get('variant-radios')) {  
    customElements.define('variant-radios', VariantRadios);
}

export {
    VariantSelects,
    VariantRadios
}

